import React, { useState, useEffect } from "react";



import { useTable } from "react-table";
import * as XLSX from "xlsx";
import db from "./Firebase";
import { useNavigate, Link, useParams } from 'react-router-dom';
import { collection, query, where, addDoc, getDocs, doc, updateDoc } from "firebase/firestore";
import Swal from "sweetalert2";

const CourseAttendanceUpdate = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [courseName, setCourseName] = useState("");
    const [day, setDay] = useState("");
    const navigate = useNavigate();
    const [email, setEmail] = useState("");


    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        setEmail(storedUsername)

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }

    }, []);

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const parsedData = XLSX.utils.sheet_to_json(sheet);

            setData(parsedData);

            // Ensure all phone numbers are stored as strings
            const extractedPhones = parsedData.map((item) => item.phone.toString().trim()).filter(Boolean);
            setPhoneNumbers(extractedPhones);

            if (parsedData.length > 0) {
                setCourseName(parsedData[0]["course"]?.trim() || ""); // Trim spaces from course name
                setDay(parsedData[0]["day"] || "");
            }
        };

        reader.readAsBinaryString(file);
    };


    const updateLessonTimes = async () => {
        setLoading(true);
        try {
            if (phoneNumbers.length === 0 || !courseName) {
                Swal.fire("Error", "Missing required data from uploaded file!", "error");
                setLoading(false);
                return;
            }

            let updatedCount = 0;
            const updatePromises = [];

            for (const phone of phoneNumbers) {
                const q = query(
                    collection(db, "nv_enrolled_courses"),
                    where("course_name", "==", courseName),
                    where("phone_no", "==", phone.toString())
                );

                const querySnapshot = await getDocs(q);

                if (querySnapshot.empty) {
                    continue;
                }

                for (const courseDoc of querySnapshot.docs) {
                    const courseRef = doc(db, "nv_enrolled_courses", courseDoc.id);
                    const courseData = courseDoc.data();

                    const updatedLessons = courseData.lessons.map((lesson, index) =>
                        index === parseInt(day) - 1
                            ? { ...lesson, completion_percentage: "100%", is_completed: "yes" }
                            : lesson
                    );

                    updatePromises.push(updateDoc(courseRef, { lessons: updatedLessons }));
                    updatedCount++;
                }
            }

            await Promise.all(updatePromises);
            setLoading(false);
            // ✅ Add log entry in "nv_backend_logs"
            const logEntry = {
                created_date: new Date(), // Current timestamp
                email: email || "unknown", // Fallback if email is missing
                page: "CourseAttendanceUpdate",
                action: `Course name : ${courseName},  Updated 100% for : ${phoneNumbers}`,
            };

            await addDoc(collection(db, "nv_backend_logs"), logEntry);
            console.log("Log entry added:", logEntry);
            Swal.fire("Success", `Updated lesson times for ${updatedCount} users!`, "success");
        } catch (error) {
            console.error("Error updating lesson times:", error);
            setLoading(false);
            Swal.fire("Error", "Failed to update lesson times!", "error");
        }
    };

    const columns = React.useMemo(
        () => [
            { Header: "Course", accessor: "course" },
            { Header: "Phone No", accessor: "phone" },
            { Header: "Day", accessor: "day" },
        ],
        []
    );

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });

    return (
        // <div className="max-w-5xl mx-auto p-6 bg-white shadow-lg rounded-lg">
        //     <h2 className="text-2xl font-semibold text-gray-700 mb-4">Update Course Attendance</h2>

        //     <div className="flex items-center gap-3 mb-6" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        //         <label className="text-gray-700 font-medium">Upload Excel File:</label>
        //         <input
        //             type="file"
        //             accept=".xlsx, .xls"
        //             onChange={handleFileUpload}
        //             className="px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        //         />
        //         <button
        //             onClick={updateLessonTimes}

        //             className={`px-5 py-2 btn btn-primary mt-3 rounded border transition-all duration-300 ${loading ? "btn btn-primary text-gray-700 cursor-not-allowed" : "bg-green-600 text-white hover:bg-green-700"}`}
        //             disabled={loading}
        //         >
        //             {loading ? "Updating..." : "Update"}
        //         </button>
        //     </div>


        //     {/* Data Table */}
        //     {data.length > 0 && (
        //         <div className="border border-gray-300 p-4 rounded-lg shadow-sm mt-6">
        //             <h3 className="text-lg font-medium text-gray-700 mb-3">Uploaded Data Preview</h3>
        //             <table {...getTableProps()} className="w-full border border-gray-300">
        //                 <thead>
        //                     {headerGroups.map((headerGroup) => (
        //                         <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100">
        //                             {headerGroup.headers.map((column) => (
        //                                 <th {...column.getHeaderProps()} className="border p-3 text-left">
        //                                     {column.render("Header")}
        //                                 </th>
        //                             ))}
        //                         </tr>
        //                     ))}
        //                 </thead>
        //                 <tbody {...getTableBodyProps()}>
        //                     {rows.map((row, i) => {
        //                         prepareRow(row);
        //                         return (
        //                             <tr {...row.getRowProps()} className={i % 2 === 0 ? "bg-gray-50" : "bg-white"}>
        //                                 {row.cells.map((cell) => (
        //                                     <td {...cell.getCellProps()} className="border p-3">
        //                                         {cell.render("Cell")}
        //                                     </td>
        //                                 ))}
        //                             </tr>
        //                         );
        //                     })}
        //                 </tbody>
        //             </table>
        //         </div>
        //     )}
        // </div>

        <>

            <>
                <div className="p-2 d-flex justify-content-between">
                    <Link to="/">
                        <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                    </Link>
                </div>

                <div className="p-3">
                    <h6 className="mb-2"> <h2>Update Course Attendance</h2></h6>
                    <div className="card-header pb-0 px-3 d-flex justify-content-end">

                        <Link to="/course_video_update">
                            <button className="btn btn-success btn-sm mr-3" >
                                Course Video Update
                            </button>
                        </Link>
                        <Link to="/course_timestamp_update">
                            <button className="btn btn-success btn-sm" >
                                Course Timestamp Update
                            </button>
                        </Link>

                    </div>

                    <div className="">
                        <div className="flex items-center gap-3 mb-6" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <label className="text-gray-700 font-medium">Upload Excel File:</label>
                            <input
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                className="px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <button
                                onClick={updateLessonTimes}

                                className={`px-5 py-2 btn btn-primary mt-3 rounded border transition-all duration-300 ${loading ? "btn btn-primary text-gray-700 cursor-not-allowed" : "bg-green-600 text-white hover:bg-green-700"}`}
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update"}
                            </button>
                        </div>


                        {/* Data Table */}
                        {data.length > 0 && (
                            <div className="border border-gray-300 p-4 rounded-lg shadow-sm mt-6">
                                <h3 className="text-lg font-medium text-gray-700 mb-3">Uploaded Data Preview</h3>
                                <div className="table-responsive fix-width scroll-inner">
                                    <table {...getTableProps()} className="table table-bordered table-hover">
                                        <thead>
                                            {headerGroups.map((headerGroup) => (
                                                <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100">
                                                    {headerGroup.headers.map((column) => (
                                                        <th {...column.getHeaderProps()} className="border p-3 text-left">
                                                            {column.render("Header")}
                                                        </th>
                                                    ))}
                                                </tr>
                                            ))}
                                        </thead>
                                        <tbody {...getTableBodyProps()}>
                                            {rows.map((row, i) => {
                                                prepareRow(row);
                                                return (
                                                    <tr {...row.getRowProps()} className={i % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                                                        {row.cells.map((cell) => (
                                                            <td {...cell.getCellProps()} className="border p-3">
                                                                {cell.render("Cell")}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </>

        </>
    );
};

export default CourseAttendanceUpdate;
